import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from "@mui/material";
import { useEffect, useState } from "react";

import useCallAxios from "../../../../Hooks/useCallAxios";
import { Loading } from "../../../Atoms";
import { Pagination } from "../../TablePagination";
import { InvoiceRowBuyer } from "../InvoiceRowBuyer";
import {
  Container,
  Content,
  HeaderTable,
  StyledGrid,
  StyledGridContainer,
  TransactionsNotFoundWarn,
} from "../styles";

interface InvoiceListBuyersProps {
  setLoading?: (val: boolean) => void;
}

export const InvoiceListBuyers = ({ setLoading }: InvoiceListBuyersProps) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);

  const [buyers, setBuyers] = useState({} as any);

  const context = "invoiceBuyers";

  const {
    fetchGET: fetchInvoiceBuyers,
    requestLoading: loading,
    requestData,
  } = useCallAxios({ context });

  const emptyRows =
    page >= 0
      ? Math.max(0, (1 + page) * rowsPerPage - (buyers?.pagination?.totalItems || 0))
      : 0;

  const handleChangePage = (
    _event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    fetchInvoiceBuyers({
      queryParameters: {
        pageSize: rowsPerPage,
        page: page + 1
      },
    });
  }, [rowsPerPage, page]);

  useEffect(() => {
    setBuyers((requestData as any)?.data);
  }, [requestData]);

  useEffect(() => {
    if (setLoading) {
      setLoading(loading.GET);
    }
  }, [loading.GET]);

  return (
    <>
      <StyledGridContainer container>
        <Content>
          <StyledGrid item xs={12}>
            <Container>
              <TableContainer component={Paper}>
                <Table aria-label="tabela de compradores">
                  <HeaderTable>
                    <TableRow>
                      <TableCell style={{ width: 10 }}></TableCell>
                      <TableCell>CNPJ</TableCell>
                      <TableCell>NOME</TableCell>
                      <TableCell>IE</TableCell>
                      <TableCell>E-MAIL</TableCell>
                    </TableRow>
                  </HeaderTable>
                  <TableBody>
                    {loading.GET ? (
                      <TableRow>
                        <TableCell
                          style={{ paddingBottom: 0, paddingTop: 0 }}
                          colSpan={5}
                        >
                          <Loading />
                        </TableCell>
                      </TableRow>
                    ) : !loading.GET &&
                      buyers?.customers?.length === 0 ? (
                      <TableRow>
                        <TableCell colSpan={5}>
                          <TransactionsNotFoundWarn>
                            Nenhum comprador encontrado!
                          </TransactionsNotFoundWarn>
                        </TableCell>
                      </TableRow>
                    ) : (
                      buyers?.customers?.map((item, index) => {
                        return (
                          <InvoiceRowBuyer
                            key={index}
                            item={item}
                          />
                        );
                      })
                    )}
                    {emptyRows > 0 && (
                      <TableRow style={{ height: 53 * emptyRows }}>
                        <TableCell colSpan={5} />
                      </TableRow>
                    )}
                  </TableBody>
                  <Pagination
                    rowsPerPageOptions={[10, 25, 40]}
                    rowCount={(buyers?.pagination?.totalItems || 0)}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    handleChangePage={handleChangePage}
                    handleChangeRowsPerPage={handleChangeRowsPerPage}
                    label={"Itens por página"}
                  />
                </Table>
              </TableContainer>
            </Container>
          </StyledGrid>
        </Content>
      </StyledGridContainer>
    </>
  );
};
